module.exports = __webpack_public_path__ + "static/media/answerList.a14a9ffb.less";